// src/internal/opfs-pragmas.ts
import * as WaSqlite from "@dxos/wa-sqlite";
var DEFAULT_JOURNAL_MODE = "wal";
var DEFAULT_SYNCHRONOUS = "normal";
var applyOpfsPragmas = (sqlite3, db, options = {}) => {
  const journalMode = options.journalMode ?? DEFAULT_JOURNAL_MODE;
  const synchronous = options.synchronous ?? DEFAULT_SYNCHRONOUS;
  const pragmas = [
    ...journalMode === "wal" ? [
      "PRAGMA locking_mode=EXCLUSIVE"
    ] : [],
    `PRAGMA journal_mode=${journalMode}`,
    `PRAGMA synchronous=${synchronous}`
  ];
  for (const pragma of pragmas) {
    for (const stmt of sqlite3.statements(db, pragma)) {
      while (sqlite3.step(stmt) === WaSqlite.SQLITE_ROW) {
      }
    }
  }
};
var checkpointWal = (sqlite3, db) => {
  for (const stmt of sqlite3.statements(db, "PRAGMA wal_checkpoint(TRUNCATE)")) {
    let status;
    while (sqlite3.step(stmt) === WaSqlite.SQLITE_ROW) {
      const row = sqlite3.row(stmt);
      const first = row[0];
      if (typeof first === "number") {
        status = first;
      }
    }
    if (status !== void 0 && status !== 0) {
      throw new Error(`WAL checkpoint incomplete (status=${status}); export would omit committed frames.`);
    }
  }
};

export {
  DEFAULT_JOURNAL_MODE,
  DEFAULT_SYNCHRONOUS,
  applyOpfsPragmas,
  checkpointWal
};
//# sourceMappingURL=chunk-6A53PZGM.mjs.map
